import { graphql, useStaticQuery } from "gatsby";
import React, { FunctionComponent, useState } from "react";
import Footer from "../../components/footer";
import Navbar from "../../components/navbar";
import Context from "../../context/Context";
import TimeContext from "../../context/TimeContext";
import { LayoutProps } from "../interfaces";
import { LoginModal } from "../modals";
import { GlobalStyle, StyledLayout } from "./layoutStyles";

const Layout: FunctionComponent<LayoutProps> = ({
  children,
  className,
  footerClassName = "footerPriv",
}) => {
  const {
    site,
    allSessionsJson,
    allSpeakersJson,
    allSponsorsJson,
    allSponsorLevelsJson,
  } = useStaticQuery(query);
  const [activeLink, setActiveLink] = useState<string>("home");
  const meta = site.siteMetadata;
  const allContextData = {
    ...meta,
    sessions: allSessionsJson.agendaSessions,
    speakers: allSpeakersJson.speakers,
    sponsors: allSponsorsJson.sponsors,
    sponsorLevels: allSponsorLevelsJson.sponsorLevels,
    activeLink,
    setActiveLink,
  };
  delete allContextData.eventEndTime;
  delete allContextData.eventStartTime;
  const eventTimes = {
    end: meta.eventEndTime,
    start: meta.eventStartTime,
  };

  return (
    <TimeContext.Provider value={eventTimes}>
      <Context.Provider value={allContextData}>
        <StyledLayout className={className}>
          <GlobalStyle />
          <LoginModal />
          <Navbar />
          <div className="content">{children}</div>
          <Footer className={footerClassName} />
        </StyledLayout>
      </Context.Provider>
    </TimeContext.Provider>
  );
};

export const query = graphql`
  query LayoutQuery {
    site {
      siteMetadata {
        eventStartTime
        eventEndTime
        eventId
        hashtag
        singlePage
        email
        emailSubject
        siteName
        title
        navPagesSingle {
          disabled
          name
          path
          target
          auth
        }
        navPagesDefault {
          disabled
          name
          path
          target
          auth
        }
        socialShare {
          alt
          img
          path
        }
      }
    }
    allSessionsJson {
      agendaSessions: nodes {
        date
        startTime
        endTime
        title
        superSession {
          speakers {
            name
            image
            title
            isModerator
          }
          title
          time
        }
        description
        breakout
        abstract
        speakers {
          isModerator
          name
        }
        tile {
          buzzWord
          image
          slug
          videoId
        }
      }
    }
    allSpeakersJson {
      speakers: nodes {
        image
        name
        title
        position
        company
        bio
        disabledProfile
      }
    }
    allSponsorsJson {
      sponsors: nodes {
        name
        logo
        email
        slug
        url
        width
        sponsorLevel
      }
    }
    allSponsorLevelsJson {
      sponsorLevels: nodes {
        levels
      }
    }
  }
`;

export default Layout;
